export default __webpack_public_path__ + "media/images/landing-8-550x420-6c1202662f816324cc76e83d8d7e711e.jpg";